import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

/**
 * @file 常用方法
 * @author alfielv
 */
import _ from 'lodash';
import ReactDOM from 'react-dom';
import { useCallback, useEffect } from 'react';
import message from '../../components/Message';
import useDialog from '../../hooks/useDialog';
import request from '../../utils/Request';
var originHistory = window.history;

var ajaxRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(requestConfig, successMessage, errorMessage, onSuccess, onError) {
    var url, options;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            url = requestConfig.url, options = _objectWithoutProperties(requestConfig, ["url"]);
            _context.next = 4;
            return request.request(url, options);

          case 4:
            successMessage && message.success(successMessage);
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            _context.next = 12;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            message.error(errorMessage || _context.t0.message || _context.t0 || '请求失败');
            onError === null || onError === void 0 ? void 0 : onError();

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function ajaxRequest(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

export default (function (props) {
  var _ref2 = props || {},
      context = _ref2.context; // eslint-disable-next-line @typescript-eslint/naming-convention


  var _useDialog = useDialog(),
      Dialog = _useDialog.Dialog,
      setDialogOptions = _useDialog.setDialogOptions; // const history = useHistory();


  var handleAjaxAction = useCallback(function (action) {
    var requestConfig = action.requestConfig,
        ignoreConfirm = action.ignoreConfirm,
        confirmTitle = action.confirmTitle,
        confirmText = action.confirmText,
        successMessage = action.successMessage,
        errorMessage = action.errorMessage,
        onSuccess = action.onSuccess,
        onError = action.onError;

    if (!ignoreConfirm) {
      // 无二次确认
      setDialogOptions({
        config: {
          type: 'confirm',
          title: confirmTitle || '确认',
          onSubmit: function onSubmit() {
            ajaxRequest(requestConfig, successMessage, errorMessage, onSuccess, onError);
          }
        },
        content: confirmText || '确认操作'
      });
    } else {
      // 有二次确认
      ajaxRequest(requestConfig, successMessage, errorMessage, onSuccess, onError);
    }
  }, [setDialogOptions]);
  var handleRedirectAction = useCallback(function (action) {
    var blank = action.blank,
        url = action.url,
        path = action.path,
        handler = action.handler; // 基于location打开链接

    if (url) {
      blank === true ? window.open(url) : window.location.href = url;
      return;
    } // 基于push state更新路由


    if (path) {
      _.isFunction(handler) ? handler(path) : originHistory.pushState(null, '', path);
      return;
    }

    console.error('[useAction Error]: 未配置Link 路径');
  }, []);
  var handleDialogAction = useCallback(function (action) {
    setDialogOptions(_objectSpread({
      type: 'dialog'
    }, action));
  }, [setDialogOptions]);
  var handleDrawerAction = useCallback(function (action) {
    setDialogOptions(_objectSpread({
      type: 'drawer'
    }, action));
  }, [setDialogOptions]);
  var handleCustomAction = useCallback(function (action) {
    var func = action.func;
    func === null || func === void 0 ? void 0 : func();
  }, []);
  var handleAction = useCallback(function (type, props) {
    switch (type) {
      case 'ajax':
        handleAjaxAction(props);
        break;

      case 'link':
        handleRedirectAction(props);
        break;

      case 'dialog':
        handleDialogAction(props);
        break;

      case 'drawer':
        handleDrawerAction(props);
        break;

      case 'custom':
        {
          handleCustomAction(props);
          break;
        }

      default:
        break;
    }
  }, [handleAjaxAction, handleRedirectAction, handleDialogAction, handleDrawerAction, handleCustomAction]); // 自动挂载一个新的Dialog

  useEffect(function () {
    // 声明使用调用侧上下文，不使用自动挂载。
    if (context) {
      return;
    }

    if (_.isNil(Dialog)) {
      return;
    }

    var div = document.createElement('div');
    document.body.appendChild(div);
    ReactDOM.render(Dialog, div);
    return function () {
      var _div$parentNode;

      ReactDOM.unmountComponentAtNode(div);
      (_div$parentNode = div.parentNode) === null || _div$parentNode === void 0 ? void 0 : _div$parentNode.removeChild(div);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Dialog]);
  return _objectSpread({
    handleAction: handleAction
  }, context && {
    dialogComponent: Dialog
  });
});